import ConcatText from 'components/ConcatText';
import Icon from 'components/Icon';
import { TCardData } from 'types';
import NoAvatar from '../../assets/images/avatar.svg';

type Props = {
  isChoose?: boolean;
  onChoose: () => void;
  onDetail: () => void;
  data: TCardData;
  disabledChoose?: boolean;
  isMeeting?: boolean;
  showShiftTime?: boolean;
  icon?: string;
};

const CardGirl = ({
  isChoose = false,
  onChoose,
  onDetail,
  data,
  disabledChoose,
  showShiftTime = false,
  icon = 'check',
}: Props): JSX.Element => {
  return (
    <div
      className={`rounded-[8px] w-40 border ${
        isChoose ? 'border-primary' : 'border-neutral-200'
      } flex flex-col cursor-pointer flex-shrink-0 justify-center items-center`}
      onClick={onDetail}
    >
      <div className="w-full relative">
        <img
          alt=""
          src={data.avatar}
          className="aspect-square object-cover object-top w-full rounded-t-[8px]"
          draggable="false"
          onError={(e) => (e.currentTarget.src = NoAvatar)}
        />
        <div
          className={`absolute flex justify-center items-center w-18px h-18px rounded-[4px] border ${
            isChoose ? 'bg-primary-50 border-primary' : 'border-neutral'
          } top-6px right-6px ${disabledChoose && !isChoose ? 'hidden' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            onChoose();
          }}
        >
          {isChoose && <Icon icon={icon} />}
        </div>
      </div>
      <div
        className={`w-full h-full text-[12px] flex flex-col gap-2 items-center px-8px py-4px rounded-b-[8px] ${
          isChoose && 'bg-primary-50'
        }`}
      >
        <div className="flex items-center justify-center gap-2 w-full">
          <ConcatText
            prefixText={data.nickname}
            suffixText={data.id}
            hyphen=""
            className={`font-bold ${
              data.isPeriodTime ? 'max-w-[80%]' : 'max-w-full'
            }`}
          />
          {data.isPeriodTime && (
            <img src="/images/menstruation.png" alt="" className="w-5 h-5" />
          )}
        </div>
      </div>
    </div>
  );
};

export default CardGirl;
